import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { getTagSlug } from 'features/tags/utils/tag'
import type { TagItem } from 'features/tags/types/tags.types'

type EditTagVariables = {
	id: number
	data: Pick<TagItem, 'name'>
}

type UseEditTagMutationProps = {
	onSuccess: () => void
}

export const useEditTagMutation = ({ onSuccess }: UseEditTagMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editTag, isPending: editTagLoading } = useMutation({
		mutationFn: ({ id, data: { name } }: EditTagVariables) => {
			return axiosPrivate.patch(apiRoutes.tag(String(id)), { name, slug: getTagSlug(name) })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
			useToast({ type: 'success', message: t('Tag updated') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editTag,
		editTagLoading
	}
}
